import { styled } from '@mui/material/styles';
import { Box } from "@mui/material";

export const DetailsContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '0.5rem 0',
});

export const DetailItem = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0.75rem 1rem',
    background: '#2a2a2a',
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    '&:hover': {
        background: '#333333',
        transform: 'translateX(5px)',
    },
    '& span:first-of-type': {
        fontWeight: 500,
        color: '#A4A4A4',
        fontSize: '0.9rem',
    },
    '& span:last-of-type': {
        fontWeight: 600,
        color: '#fff',
        fontSize: '0.95rem',
    },
});

export const SuccessItem = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    width: '100%',
    padding: '1rem',
    background: 'linear-gradient(135deg, rgba(76, 175, 80, 0.1) 0%, rgba(76, 175, 80, 0.05) 100%)',
    borderRadius: '8px',
    border: '1px solid rgba(76, 175, 80, 0.3)',
    '& span': {
        color: '#4caf50 !important',
        fontSize: '1.1rem',
        fontWeight: 600,
    },
});

export const AlertItem = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    width: '100%',
    padding: '1rem',
    background: 'linear-gradient(135deg, rgba(255, 152, 0, 0.1) 0%, rgba(255, 152, 0, 0.05) 100%)',
    borderRadius: '8px',
    border: '1px solid rgba(255, 152, 0, 0.3)',
    '& span': {
        color: '#ff9800 !important',
        fontSize: '1.1rem',
        fontWeight: 600,
    },
});